import React, { useCallback, useMemo } from "react";

import { useCustomSearchParams } from "../../../../hooks/useCustomSearchParams";
import CustomMenu from "../../../../components/Menu";
import { useResponsive } from "../../../../hooks/useResponsive";
import { CustomButton } from "../../../../components/Button/Button";
import { userStatus } from "../../../../utils/constants/index.js";
import { FilterOptionsList } from "../../../../components/FilterOptionsList.js";
import { DownArrowIcon } from "../../../../components/DownArrowIcon.js";

function FilterStatus() {
  const [statusFilterMenu, setStatusFilterMenu] = React.useState(null);
  const [userFilter, updateParams, removeSearchParam] =
    useCustomSearchParams("users-status");
  const isMobile = useResponsive("down", "md");

  const handleClick = useCallback((event) => {
    setStatusFilterMenu(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setStatusFilterMenu(null);
  }, []);

  const openFilterMenu = Boolean(statusFilterMenu);

  return (
    <div className="mr-2">
      {isMobile ? (
          <FilterOptionsList options={userStatus} paramsKey={"users-status"} filterType={userFilter}/>
      ) : (
        <CustomButton
          variant="outlined"
          color="primary"
          className="filter-btn white-button"
          onClick={handleClick}
          endIcon={<DownArrowIcon/>}
        >
          <p className="mr-4 capitalize">{userFilter || "Status"}</p>
        </CustomButton>
      )}
      <CustomMenu
        open={openFilterMenu}
        handleClose={handleClose}
        anchorEl={statusFilterMenu}
      >
        <FilterOptionsList options={userStatus} paramsKey={"users-status"} filterType={userFilter}/>
      </CustomMenu>
    </div>
  );
}

export default React.memo(FilterStatus);
